module.exports = __webpack_public_path__ + "img/47.ed0d5729.png";